import React from 'react';

const PeriodList = ({ periods }) => {
    // If periods array is empty or undefined, show a message or loading indicator
    if (!periods || periods.length === 0) {
        return <p>No periods to display.</p>;
    }

    return (
        <div>
            <h2>Period List</h2>
            <ul>
                {periods.map((period, index) => (
                    <li key={index}>
                        <strong>Puberty Date:</strong> {formatDate(period.pubertyDate)} <br />
                        <strong>Puberty Issues:</strong> {period.pubertyIssues} <br />
                        <strong>Last Period Date:</strong> {formatDate(period.lastPeriodDate)} <br />
                        <strong>Period Duration:</strong> {period.periodDuration} days <br />
                        <strong>Usual Cycle Length:</strong> {period.usualCycleLength} days <br />
                    </li>
                ))}
            </ul>
        </div>
    );
};

// Helper function to format dates as yyyy-MM-dd
const formatDate = (date) => {
    if (!date) return '';
    const formattedDate = new Date(date);
    return formattedDate.toISOString().split('T')[0];
};

export default PeriodList;
